import React from 'react';
import { Button, Grid } from '@material-ui/core';
import {
  EntityApiDefinitionCard,
  // EntityConsumedApisCard,
  EntityConsumingComponentsCard,
  EntityHasApisCard,
  // EntityProvidedApisCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import {
  EntityAboutCard,
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityHasComponentsCard,
  EntityHasResourcesCard,
  // EntityHasSubcomponentsCard,
  EntityHasSystemsCard,
  EntityLinksCard,
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  isComponentType,
  isKind,
  hasCatalogProcessingErrors,
  isOrphan,
  hasRelationWarnings,
  EntityRelationWarning,
  EntityLayout,
} from '@backstage/plugin-catalog';
import {
  EntityUserProfileCard,
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { EmptyState } from '@backstage/core-components';
import {
  Direction,
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';

import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';

import {
  EntityKubernetesContent,
  isKubernetesAvailable,
} from '@backstage/plugin-kubernetes';
import { CdImageUpdateWorkflowPage } from '@internal/backstage-plugin-cd-image-update-workflow';
import { EntityDeployV3Content } from '@internal/backstage-plugin-deploy-v3';
// import { GithubWorkflowsPage } from '@internal/backstage-plugin-github-workflows';
// import { CiCdPage } from '@internal/backstage-plugin-ci-cd';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  // alertApiRef,
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { ScalingWorkflowPage } from '@internal/backstage-plugin-scaling';
import { ManifestOptionsPage } from '@internal/backstage-plugin-service-creator';
import { InfraCreatorPage } from '@internal/backstage-plugin-infra-creator';
import { GcrInfoPage } from '@internal/backstage-plugin-gcr-info';
import { GkeOptionsPage } from '@internal/backstage-plugin-gke-options';
import { useNotifications } from '@internal/backstage-plugin-notifications';
import { EnvPage } from '@internal/backstage-plugin-env';

const techdocsContent = (
  <EntityTechdocsContent>
    <TechDocsAddons>
      <ReportIssue />
    </TechDocsAddons>
  </EntityTechdocsContent>
);
const WorkflowRunnerContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <CdImageUpdateWorkflowPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
const cicdContent = (
  // This is an example of how you can implement your company's logic in entity page.
  // You can for example enforce that all components of type 'service' should use GitHubActions
  <EntitySwitch>
    {/*
      Here you can add support for different CI/CD services, for example
      using @backstage-community/plugin-github-actions as follows:
      <EntitySwitch.Case if={isGithubActionsAvailable}>
        <EntityGithubActionsContent />
      </EntitySwitch.Case>
     */}

    <EntitySwitch.Case>
      <EmptyState
        title="No CI/CD available for this entity"
        missing="info"
        description="You need to add an annotation to your component if you want to enable CI/CD for it. You can read more about annotations in Backstage by clicking the button below."
        action={
          <Button
            variant="contained"
            color="primary"
            href="https://backstage.io/docs/features/software-catalog/well-known-annotations"
          >
            Read more
          </Button>
        }
      />
    </EntitySwitch.Case>
  </EntitySwitch>
);

const entityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid item xs={12}>
          <EntityOrphanWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Grid item xs={12}>
          <EntityRelationWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid item xs={12}>
          <EntityProcessingErrorsPanel />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

const overviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard height={400} />
    </Grid>
  </Grid>
);
// const Workflows = (
//   <EntitySwitch>
//     <EntitySwitch.Case>
//       <GithubWorkflowsPage />
//     </EntitySwitch.Case>
//     <EntitySwitch.Case>
//       <EmptyState
//         title="No CI/CD available for this entity"
//         missing="info"
//         description="You need to add an annotation to your component if you want to enable CI/CD for it. You can read more
//           about annotations in Backstage by clicking the button below."
//         action={
//           <Button
//             variant="contained"
//             color="primary"
//             href="https://backstage.io/docs/features/software-catalog/well-known-annotations"
//           >
//             Read more
//           </Button>
//         }
//       />
//     </EntitySwitch.Case>
//   </EntitySwitch>
// );
// const CiCd = (
//   <EntitySwitch>
//     <EntitySwitch.Case>
//       <CiCdPage />
//     </EntitySwitch.Case>
//   </EntitySwitch>
// );
const ReplicaWorkflowContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <ScalingWorkflowPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
// const serviceEntityPage = (
//   <EntityLayout>
//     <EntityLayout.Route path="/" title="Overview">
//       {overviewContent}
//     </EntityLayout.Route>
//     <EntityLayout.Route path="/ci-cd" title="CI/CD">
//       {CiCd}
//     </EntityLayout.Route>
//     (
//     <EntityLayout.Route path="/github-workflows" title="Infra Workflow">
//       {Workflows}
//     </EntityLayout.Route>
//     )
//     <EntityLayout.Route path="/WorkflowRunner" title="Update Sha Workflow">
//       {WorkflowRunnerContent}
//     </EntityLayout.Route>
//   </EntityLayout>
// );
const ManifestGeneratorContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <ManifestOptionsPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
const InfraCreatorContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <InfraCreatorPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
const GcrInfoContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <GcrInfoPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
const GKEOptionsContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <GkeOptionsPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
const EnvCreatorContent = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <EnvPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);

const ServiceEntityPage = () => {
  const { entity } = useEntity();
  const projectId = entity.metadata.project_id;
  const { fetch } = useApi(fetchApiRef);
  // const alert = useApi(alertApiRef);
  const discoveryApi = useApi(discoveryApiRef);
  const [updateSha, setUpdateSha] = React.useState(false);
  // const [cicd, setCicd] = React.useState(false);
  // const [infraworkflow, setInfraworkflow] = React.useState(false);
  const [scaling, setScaling] = React.useState(false);
  const [infra, setInfra] = React.useState(false);
  const [gcr, setGcr] = React.useState(false);
  const [manifestGenerator, setManifestGenerator] = React.useState(false);
  const [gkeOptions, setGkeOptions] = React.useState(false);
  const [updateEnv, setUpdateEnv] = React.useState(false);
  // Deploy (v3) tab gate — deploy-v3's OWN deploy.view (2026-07-22). It once
  // reused the Deploy v2 `/authorize` decision, which hid the v3 tab from every
  // role that held only v3 grants. Deploy v2 was removed on 2026-10-11.
  const [deployV3, setDeployV3] = React.useState(false);
  const notify = useNotifications();
  // React.useEffect(() => {
  //   const checkUserAccess = async () => {
  //     try {
  //       if (projectId === undefined) {
  //         setCicd(false);
  //         return;
  //       }
  //       const res = await fetch(
  //         `${await discoveryApi.getBaseUrl('ci-cd-backend')}/authorize`,
  //         {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify({ projectId: projectId }),
  //         },
  //       );
  //       if (res.ok) {
  //         const data = await res.json();
  //         if (data.decision) {
  //           setCicd(true);
  //         } else {
  //           setCicd(false);
  //         }
  //       } else {
  //         alert.post({
  //           severity: 'error',
  //           message: 'Error Fetching User Access Data',
  //         });
  //         setCicd(false);
  //       }
  //     } catch (error) {
  //       alert.post({
  //         severity: 'error',
  //         message: 'Error Fetching User Access Data',
  //       });
  //       setCicd(false);
  //     }
  //   };

  //   checkUserAccess();
  // }, [fetch, discoveryApi, projectId, alert]);
  // React.useEffect(() => {
  //   const checkUserAccess = async () => {
  //     try {
  //       if (projectId === undefined) {
  //         setInfraworkflow(false);
  //         return;
  //       }
  //       const res = await fetch(
  //         `${await discoveryApi.getBaseUrl(
  //           'github-workflows-backend',
  //         )}/authorize`,
  //         {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify({ projectId: projectId }),
  //         },
  //       );
  //       if (res.ok) {
  //         const data = await res.json();
  //         if (data.decision) {
  //           setInfraworkflow(true);
  //         } else {
  //           setInfraworkflow(false);
  //         }
  //       } else {
  //         alert.post({
  //           severity: 'error',
  //           message: 'Error Fetching User Access Data',
  //         });
  //         setInfraworkflow(false);
  //       }
  //     } catch (error) {
  //       alert.post({
  //         severity: 'error',
  //         message: 'Error Fetching User Access Data',
  //       });
  //       setInfraworkflow(false);
  //     }
  //   };

  //   checkUserAccess();
  // }, [fetch, discoveryApi, projectId, alert]);
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setUpdateSha(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl(
            'cd-image-update-workflow-backend',
          )}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );

        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setUpdateSha(true);
          } else {
            setUpdateSha(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setUpdateSha(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setUpdateSha(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setScaling(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl('scaling-backend')}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );

        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setScaling(true);
          } else {
            setScaling(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setScaling(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setScaling(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setManifestGenerator(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl(
            'service-creator-backend',
          )}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );
        // eslint-disable-next-line no-console
        console.log(res);
        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setManifestGenerator(true);
          } else {
            setManifestGenerator(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setManifestGenerator(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setManifestGenerator(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setInfra(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl('infra-creator-backend')}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );
        // eslint-disable-next-line no-console
        console.log(res);
        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setInfra(true);
          } else {
            setInfra(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setInfra(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setInfra(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setGcr(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl('gcr-info-backend')}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );
        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setGcr(true);
          } else {
            setGcr(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setGcr(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setGcr(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setGkeOptions(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl('gke-options-backend')}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );
        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setGkeOptions(true);
          } else {
            setGkeOptions(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setGkeOptions(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setGkeOptions(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (projectId === undefined) {
          setUpdateEnv(false);
          return;
        }
        const res = await fetch(
          `${await discoveryApi.getBaseUrl('env-backend')}/authorize`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ projectId: projectId }),
          },
        );
        if (res.ok) {
          const data = await res.json();
          if (data.decision) {
            setUpdateEnv(true);
          } else {
            setUpdateEnv(false);
          }
        } else {
          // alert.post({
          //   severity: 'error',
          //   message: 'Error Fetching User Access Data',
          // });
          notify('Error Fetching User Access Data', undefined, 'error');
          setUpdateEnv(false);
        }
      } catch (error) {
        // alert.post({
        //   severity: 'error',
        //   message: 'Error Fetching User Access Data',
        // });
        notify('Error Fetching User Access Data', undefined, 'error');
        setUpdateEnv(false);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const checkUserAccess = async () => {
      try {
        const res = await fetch(
          `${await discoveryApi.getBaseUrl('deploy-v3')}/permissions/self`,
        );
        if (res.ok) {
          const data = await res.json();
          // Same check as EntityDeployPage's own probe: anything but a hard
          // DENY shows the tab — conditional grants count, and the page
          // scopes per-entity/env internally. The backend returns
          // AuthorizeResult strings ('ALLOW' | 'DENY' | 'CONDITIONAL').
          setDeployV3(data.view !== 'DENY');
        } else {
          // Fail OPEN, mirroring EntityDeployPage: a broken probe shows the
          // tab (server still enforces RBAC on every action) instead of
          // silently hiding it — a silent hide is exactly the failure mode
          // that made the v2 gate-reuse incident hard to spot.
          setDeployV3(true);
        }
      } catch (error) {
        setDeployV3(true);
      }
    };

    checkUserAccess();
  }, [fetch, discoveryApi]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        {overviewContent}
      </EntityLayout.Route>

      {/* {cicd && (
        <EntityLayout.Route path="/ci-cd" title="CI/CD">
          {CiCd}
        </EntityLayout.Route>
      )} */}

      {/* {infraworkflow && (
        <EntityLayout.Route path="/github-workflows" title="Infra Workflow">
          {Workflows}
        </EntityLayout.Route>
      )} */}

      {updateSha && (
        <EntityLayout.Route path="/WorkflowRunner" title="Update Sha Workflow">
          {WorkflowRunnerContent}
        </EntityLayout.Route>
      )}
      {scaling && (
        <EntityLayout.Route path="/scaling" title="Scaling Workflow">
          {ReplicaWorkflowContent}
        </EntityLayout.Route>
      )}
      {manifestGenerator && (
        <EntityLayout.Route path="/manifest-options" title="Manifest Options">
          {ManifestGeneratorContent}
        </EntityLayout.Route>
      )}
      {infra && (
        <EntityLayout.Route path="/infra-creator" title="Infra Creator">
          {InfraCreatorContent}
        </EntityLayout.Route>
      )}
      {gcr && (
        <EntityLayout.Route path="/gcr-info" title="Gcr Info">
          {GcrInfoContent}
        </EntityLayout.Route>
      )}
      {gkeOptions && (
        <EntityLayout.Route
          path="/gke-options"
          title="Private Cluster Package Additional Setups"
        >
          {GKEOptionsContent}
        </EntityLayout.Route>
      )}
      {updateEnv && (
        <EntityLayout.Route path="/env" title="Env Creator">
          {EnvCreatorContent}
        </EntityLayout.Route>
      )}
      {/*
        Deploy v3 — gated on deploy-v3's OWN deploy.view via
        /permissions/self (2026-07-22). Previously reused the Deploy v2
        authorize decision, which hid this tab from every role holding only
        v3 grants once v2 permissions were stripped
        (engineering-backstage-access incident, role edit 07:19). The Deploy
        v2 tab was removed on 2026-10-11.
      */}
      {deployV3 && (
        <EntityLayout.Route path="/deploy-v3" title="Deploy (v3)">
          <EntityDeployV3Content />
        </EntityLayout.Route>
      )}
    </EntityLayout>
  );
};

const websiteEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/ci-cd" title="CI/CD">
      {cicdContent}
    </EntityLayout.Route>

    <EntityLayout.Route
      path="/kubernetes"
      title="Kubernetes"
      if={isKubernetesAvailable}
    >
      <EntityKubernetesContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/dependencies" title="Dependencies">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityDependsOnComponentsCard />
        </Grid>
        <Grid item md={6}>
          <EntityDependsOnResourcesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);

/**
 * NOTE: This page is designed to work on small screens such as mobile devices.
 * This is based on Material UI Grid. If breakpoints are used, each grid item must set the `xs` prop to a column size or to `true`,
 * since this does not default. If no breakpoints are used, the items will equitably share the available space.
 * https://material-ui.com/components/grid/#basic-grid.
 */

const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);

const componentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>
      <ServiceEntityPage />
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {websiteEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);

const apiPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid container item md={12}>
          <Grid item md={6}>
            <EntityProvidingComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityConsumingComponentsCard />
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const userPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityUserProfileCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const groupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityGroupProfileCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityMembersListCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityLinksCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const systemPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid item md={8}>
          <EntityHasComponentsCard />
        </Grid>
        <Grid item md={6}>
          <EntityHasApisCard />
        </Grid>
        <Grid item md={6}>
          <EntityHasResourcesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        direction={Direction.TOP_BOTTOM}
        title="System Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_HAS_PART,
          RELATION_API_CONSUMED_BY,
          RELATION_API_PROVIDED_BY,
          RELATION_CONSUMES_API,
          RELATION_PROVIDES_API,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </EntityLayout.Route>
  </EntityLayout>
);

const domainPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard height={400} />
        </Grid>
        <Grid item md={6}>
          <EntityHasSystemsCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')} children={componentPage} />
    <EntitySwitch.Case if={isKind('api')} children={apiPage} />
    <EntitySwitch.Case if={isKind('group')} children={groupPage} />
    <EntitySwitch.Case if={isKind('user')} children={userPage} />
    <EntitySwitch.Case if={isKind('system')} children={systemPage} />
    <EntitySwitch.Case if={isKind('domain')} children={domainPage} />

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
